import { initializeApp } from 'firebase/app';
import firebase from 'firebase/compat/app';
import 'firebase/analytics';
require ('firebase/auth');
require ('firebase/firestore');
require ('firebase/storage');

// Initialize Firebase
const firebaseConfig = 
{
  apiKey: "AIzaSyAYT1y0RehPh18wvYdAJT1huZiwHRuOQxk",
  authDomain: "spot360vlog.firebaseapp.com",
  projectId: "spot360vlog",
  storageBucket: "spot360vlog.appspot.com",
  messagingSenderId: "562921313979",
  appId: "1:562921313979:web:3890f024731569263e3b9e",
  measurementId: "G-0T45RB2SPF"
};

initializeApp(firebaseConfig);

export default firebase;